import { css } from "@compiled/react";

import { wacToken } from "@/libraries/design/foundations";

export const PrivacyPolicy = () => (
    <div css={privacyPolicyCss}>
        <p>
            More important information about Rovo Dev Agents can be found in our{" "}
            <a
                css={linkCss}
                href="https://rovodevagents-beta.atlassian.net/wiki/external/YmQ4YTllN2EyZTJmNGNmMTkwYTllMTZkYjk2MGRiNDU#Things-you-should-know"
            >
                set up guide
            </a>
            . We may contact you by email to let you know when new agents become
            available as part of the beta program.
        </p>
        <p>
            Rovo Dev CLI enables users to connect to third-party data sources
            via Model Context Protocol.{" "}
            <a
                css={linkCss}
                href="https://rovodevagents-beta.atlassian.net/wiki/external/ZDQxM2VhODI2MjJkNDI3M2IwMjgyNzNjZWIwYjJhYTM"
            >
                Learn more here
            </a>
        </p>
    </div>
);

const privacyPolicyCss = css({
    fontSize: 13
});

const linkCss = css({
    color: wacToken("color.primary.blue"),
    textDecoration: "underline",
    [":hover"]: {
        textDecoration: "none"
    }
});
